// Holds every add-to-cart button on the page while one add is under way. A
// second add must not go out before the first is in the cart and the prices it
// moves (personal-price.js) are painted again: the customer would otherwise
// click on a price the cart no longer charges.
//
// Woo's loop buttons and the side cart's single product form both announce an
// add as adding_to_cart and its success as added_to_cart. A guest's prices cannot
// move, so added_to_cart ends the hold; a logged-in customer's ends with the
// price refresh that event sets off. Styling lives in scss/_cart-lock.scss.

const BUTTONS = '.add_to_cart_button, .single_add_to_cart_button';
// a failed add announces nothing, and its button must not stay dead
const MAX_HOLD = 15000;

let locked = false;
let awaitingPrices = false;
let releaseTimer = null;

function setDisabled(disabled) {
    document.querySelectorAll(BUTTONS).forEach((button) => {
        if (disabled) {
            button.setAttribute('aria-disabled', 'true');
        } else {
            button.removeAttribute('aria-disabled');
        }
    });
}

function lock() {
    locked = true;
    awaitingPrices = false;
    setDisabled(true);
    clearTimeout(releaseTimer);
    releaseTimer = setTimeout(release, MAX_HOLD);
}

function release() {
    locked = false;
    awaitingPrices = false;
    clearTimeout(releaseTimer);
    setDisabled(false);
}

// Capturing on document runs ahead of Woo's and CheckoutWC's handlers, which are
// delegated from body. Anchors cannot be disabled, and Enter in the quantity
// field submits the form without a click.
document.addEventListener(
    'click',
    (event) => {
        if (locked && event.target.closest(BUTTONS)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    },
    true
);
document.addEventListener(
    'submit',
    (event) => {
        if (locked && event.target.matches('form.cart')) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    },
    true
);
// Without the side cart, CheckoutWC leaves the single product form alone and it
// posts the page, announcing nothing. On window, every handler that could have
// taken the submit over has run.
window.addEventListener('submit', (event) => {
    if (!event.defaultPrevented && event.target.matches('form.cart')) {
        lock();
    }
});

// listen on document (not body): the bundle loads in <head> before <body> exists
jQuery(document).on('adding_to_cart', lock);
jQuery(document).on('ajax_request_not_sent.adding_to_cart', release);
// added_to_cart also comes from the My Deals toggle, which never locked
jQuery(document).on('added_to_cart', () => {
    if (!locked) {
        return;
    }
    if (window.sonPersonalPrice) {
        awaitingPrices = true;
    } else {
        release();
    }
});

document.addEventListener('son-personal-price-settled', () => {
    if (awaitingPrices) {
        release();
    }
});

// a page left mid-add can come back from the back/forward cache still locked
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        release();
    }
});
